const ProductRadioBtn = (root = document) => {
  const scope = root instanceof Element || root === document ? root : document;
  const customRadios = [...scope.querySelectorAll(".custom-radio")];

  if (customRadios.length > 0) {
    customRadios.forEach((radio) => {
      const imageUrl = radio.getAttribute("data-image");
      if (imageUrl) {
        radio.style.backgroundImage = `url("${imageUrl}")`;
      }
    });
  }
};

window.ProductRadioBtn = ProductRadioBtn;

export default ProductRadioBtn;
